import $ from 'jquery' // jQuery

import './module/_hashScroll' // アンカーリンクスクロール
import './module/_spMenuToggle' // SPメニュー開閉

/* global  */ // tUrl等のグローバル変数を宣言する

// import './_form.js'
import './_top'
import './_bgShift'
// import './_headAnime'
import './_bgPara'
import './_interview'
import './_business'

/*
#### ##    ## ########          #######  ########   ######
 ##  ####  ##    ##            ##     ## ##     ## ##
 ##  ## ## ##    ##    ####### ##     ## ########   ######
 ##  ##  ####    ##            ##     ## ##     ##       ##
#### ##    ##    ##             #######  ########   ######
*/
// 画面に入った監視対象に.activeを付加
// Intersection Observer
window.intObs = function (rootMargin) {
  if (!document.getElementsByClassName('js-in')[0]) {
    return
  }
  const intObsOption = {
    // root: document.querySelector('#obsArea'), // 監視領域 省略でビューポート
    rootMargin: '-30%', // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
    threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
  }
  const observer = new IntersectionObserver(intObsCallback, intObsOption)
  const intObsItems = document.getElementsByClassName('js-in')
  for (let index = 0; index < intObsItems.length; index++) {
    const intObsItem = intObsItems[index]
    observer.observe(intObsItem) // 監視対象に加える
  }
  function intObsCallback(entries) {
    for (let index = 0; index < entries.length; index++) {
      const entry = entries[index]
      if (entry.isIntersecting) {
        const entryItem = entry.target
        entryItem.classList.add('animated')
        observer.unobserve(entryItem) // 監視対象から外す
      }
    }
  }
}

if (!document.getElementById('page-top')) {
  window.intObs('-10% 0px')
} else {
  window.intObs('-20% 0px')
}

/*
 ##     ## ##     ##          ######  ##    ## ##    ##  ######
 ##     ## ##     ##         ##         ####   ####  ## ##
 ######### ##     ## #######  ######     ##    ## ## ## ##
 ##     ##  ##   ##                ##    ##    ##  #### ##
 ##     ##    ###             ######     ##    ##    ##  ######
ホバー中、その要素とその連動要素全てに.hoverを付与

<a href="" class="js-hoverSync js-hoverSync--hoge" data-hover-sync="hoge"></a>
<a href="" class="js-hoverSync js-hoverSync--hoge" data-hover-sync="hoge"></a>
*/
const hoverSyncClass = 'js-hoverSync'
if (document.getElementsByClassName(hoverSyncClass)[0]) {
  hoverSync()
}
function hoverSync() {
  const hoverActiveClass = 'hover'
  const hoverItems = document.getElementsByClassName(hoverSyncClass)
  for (let index = 0; index < hoverItems.length; index++) {
    const hoverItem = hoverItems[index]
    const hoverTargets = document.getElementsByClassName(hoverSyncClass + '--' + hoverItem.dataset.hoverSync)
    hoverItem.addEventListener(
      'mouseover',
      function () {
        for (let index = 0; index < hoverTargets.length; index++) {
          hoverTargets[index].classList.add(hoverActiveClass)
        }
      },
      false
    )
    hoverItem.addEventListener(
      'mouseout',
      function () {
        for (let index = 0; index < hoverTargets.length; index++) {
          hoverTargets[index].classList.remove(hoverActiveClass)
        }
      },
      false
    )
  }
}
